module.exports = __webpack_public_path__ + "img/xls.bc55f0e1.png";